import { Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { Stack, IconButton, IconButtonProps } from '@mui/material';
import i18next from 'i18next';
import { isFunction } from 'lodash';

import { DataGridColumnDefinition } from '../types';

type Options<T> = {
  hidden?: boolean;
  handleEdit?: (item: T) => void;
  editButtonProps?: IconButtonProps | ((item: T) => IconButtonProps);
  handleRemove?: (item: T) => void;
  removeButtonProps?: IconButtonProps | ((item: T) => IconButtonProps);
  children?: (item: T) => React.ReactNode | React.ReactNode[];
};

export function getActionsColumn<T>({
  hidden,
  handleEdit,
  handleRemove,
  children,
  editButtonProps,
  removeButtonProps,
}: Options<T>): DataGridColumnDefinition<T> {
  const { t } = i18next;
  if (!handleEdit && !handleRemove && !children) {
    return null as unknown as DataGridColumnDefinition<T>;
  }
  return {
    header: t('columns.actions'),
    valueClassName: 'tw-w-[120px]',
    hidden,
    valueGetter: (item) => (
      <Stack direction="row" spacing={1}>
        {children?.(item)}
        {handleEdit && (
          <IconButton
            color="primary"
            onClick={(e) => {
              e.stopPropagation();
              handleEdit(item);
            }}
            {...(isFunction(editButtonProps)
              ? editButtonProps(item)
              : editButtonProps)}
          >
            <EditIcon />
          </IconButton>
        )}
        {handleRemove && (
          <IconButton
            color="error"
            onClick={(e) => {
              e.stopPropagation();
              handleRemove(item);
            }}
            {...(isFunction(removeButtonProps)
              ? removeButtonProps(item)
              : removeButtonProps)}
          >
            <DeleteIcon />
          </IconButton>
        )}
      </Stack>
    ),
  };
}
